/**
 * User-related utility functions
 */

/**
 * Generates initials from an email address
 * Attempts to use first letter of first and last name parts
 * Falls back to first two characters of email if name parts aren't available
 * 
 * @param email - Email address to generate initials from
 * @returns Uppercase initials (2 characters)
 * 
 * @example
 * getInitials("john.doe@example.com") // "JD"
 * getInitials("jane@example.com") // "JA"
 */
export function getInitials(email: string): string {
  const parts = email.split("@")[0].split(/[._+-]/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return email.substring(0, 2).toUpperCase();
}
